<template>
  <div class="cmp-settings-invoice-project-details-hints">
    <label style="padding-left: 5px">{{$t('use_the_following_variables')}}:</label>
    <table class="variable-table">
      <thead>
        <tr>
          <th>{{$t('variable')}}</th>
          <th>{{$t('description')}}</th>
          <th>{{$t('example')}}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>#yyyy#</td>
          <td>for 4 digit year</td>
          <td>„2017</td>
        </tr>
        <tr>
          <td>#yy#</td>
          <td>for 2 digit year</td>
          <td>„17</td>
        </tr>
        <tr>
          <td>#nr2#</td>
          <td>for a 2 digit number</td>
          <td>„01</td>
        </tr>
        <tr>
          <td>#nr3#</td>
          <td>for a 3 digit number</td>
          <td>„001“</td>
        </tr>
        <tr>
          <td>#nr4#</td>
          <td>for a 4 digit number</td>
          <td>„0001“</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
// import { defaultTextFieldConfig } from "../../../../plugins/text-field";
// import { createCountriesTV } from "../../../../models/country.model";
// import { createCurrencyTV } from "../../../../models/currency.model";
// import { createPaymentMethodTV } from "../../../../models/payment-method.model";
// import { createMoneyAccountTV } from "../../../../models/money-account.model";
// import { tv, createTV } from "../../../../models/text-value.model";
// import InfoCard from "../../../../dt-plugins/info-card/info-card.vue";
// import DTCheckbox from "../../../../plugins/checkbox/checkbox";

export default {
  components: {
  },
  data() {
    return {
      // textFieldConfig: defaultTextFieldConfig(),
    };
  },
  props: {
    // invoiceProjectDetails: {
    //   required: true,
    // },
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss">
.cmp-settings-invoice-project-details-hints {
  .variable-table {
    width: 100%;
    padding: 5px;
    th {
      text-align: left;
      padding: 5px;
    }
    td{
      padding: 5px;
    }
    tbody {
      td:first-child {
        // font-weight: 600;
      }
    }
    tr {
      height: 25px;
    }
  }
}
</style>